import ConnectAdvancedView from './ConnectAdvancedView'

export default ConnectAdvancedView
